import { useCallback, useState } from 'react';

import { Box } from '@lyearn/ui';

import useRect from '../../hooks/useRect';

type Size = {
  height: number;
  width: number;
};

interface RectProps {
  className?: string;
  children: (props: Size) => React.ReactNode;
  disableHeight?: boolean;
  disableWidth?: boolean;
}

const Rect: React.FC<RectProps> = (props) => {
  const {
    className = 'w-full h-full',
    children,
    disableHeight = false,
    disableWidth = false,
  } = props;

  const [size, setSize] = useState<Size | null>(null);

  const onResize = useCallback(
    ({ width, height }: Partial<Size>) => {
      const newWidth = width || 0;
      const newHeight = height || 0;

      if (!disableHeight && !disableWidth) {
        setSize({ width: newWidth, height: newHeight });
      } else if (disableHeight && newWidth !== size?.width) {
        setSize({ width: newWidth, height: 0 });
      } else if (disableWidth && newHeight !== size?.height) {
        setSize({ height: newHeight, width: 0 });
      }
    },
    [size, disableHeight, disableWidth],
  );

  const { ref } = useRect({ onResize });

  return (
    <Box ref={ref} className={className}>
      {size ? children(size) : null}
    </Box>
  );
};

export default Rect;
